export enum ONEDRIVE_PICKER_KEYS {
    /**
     * @value To add a SharePoint file, paste the URL link into this field.
     * @description Helper message beneath the sharepoint url input
     */
    FILE_HELPER = 'ONEDRIVE_PICKER.FILE_HELPER',
    /**
     * @value https://www.example.sharepoint.com
     * @description Placeholder on the sharepoint url input. DO NOT TRANSLATE
     */
    FILE_PLACEHOLDER = 'ONEDRIVE_PICKER.FILE_PLACEHOLDER',
    /**
     * @value Insert SharePoint file
     * @description Title of the sharepoint file insertion dialog
     */
    INSERT_FILE = 'ONEDRIVE_PICKER.INSERT_FILE',
    /**
     * @value On your SharePoint site, go to the library where you want to share the folder.
     * @description Used in the OneDrivePicker, the key explain the first step of picking a shared folder from a Sharepoint site
     */
    MESSAGE_STEP_ONE = 'ONEDRIVE_PICKER.MESSAGE_STEP_ONE',
    /**
     * @value Select Share at the top of the page.
     * @description Used in the OneDrivePicker, the key explain the third step of picking a shared folder from a Sharepoint site
     */
    MESSAGE_STEP_THREE = 'ONEDRIVE_PICKER.MESSAGE_STEP_THREE',
    /**
     * @value Pick the folder you want to share by selecting its circle icon.
     * @description Used in the OneDrivePicker, the key explain the second step of picking a shared folder from a Sharepoint site
     */
    MESSAGE_STEP_TWO = 'ONEDRIVE_PICKER.MESSAGE_STEP_TWO',
    /**
     * @value How to find the folder URL:
     * @description Key used in the OneDrivePicker dialog, to display a message informing the user on how to get a shared url from Sharepoint site
     */
    MESSAGE_TITLE = 'ONEDRIVE_PICKER.MESSAGE_TITLE',
    /**
     * @value The URL does not look right. Ensure you paste a SharePoint file link.
     * @description Error message displayed when a user type a non sharepoint link.
     */
    NOT_SHAREPOINT_URL_ERROR = 'ONEDRIVE_PICKER.NOT_SHAREPOINT_URL_ERROR',
    /**
     * @value No access or document does not exist
     */
    NO_ACCESS = 'ONEDRIVE_PICKER.NO_ACCESS',
    /**
     * @value Search in SharePoint
     * @description Text used with an external link to redirect an user to his sharepoint site
     */
    SEARCH_IN_SHAREPOINT = 'ONEDRIVE_PICKER.SEARCH_IN_SHAREPOINT',
    /**
     * @value SharePoint folder URL
     */
    TEXT_FIELD = 'ONEDRIVE_PICKER.TEXT_FIELD',
    /**
     * @value https://sharepoint.com/foldername...
     */
    TEXT_FIELD_PLACEHOLDER = 'ONEDRIVE_PICKER.PLACEHOLDER',
    /**
     * @value Add SharePoint folder
     */
    TITLE = 'ONEDRIVE_PICKER.TITLE',
    /**
     * @value Wrong format shared URL
     * @description In the OneDrivePicker, the error message shown when the user tried to access a shared URL that is wrongly formatted
     */
    WRONG_FORMAT = 'ONEDRIVE_PICKER.WRONG_FORMAT',
}
